import Production from "components/shared/Production";
import ProductionSelector from "components/shared/ProductionSelector";
import { useContext } from "react";
import { ProductContext } from "./ProductForm";
import ProductionCategory from "./ProductionCategory";

const ProductionView = () => {
  const { product, setProduct } = useContext(ProductContext);

  return (
    <div className="card">
      <h5>Production</h5>

      <div className="mt-4 space-y-4">
        <div className="flex items-center space-x-4">
          <label htmlFor="considerBomInProduction">
            Consider BOM in Production:{" "}
          </label>
          <input
            id="considerBomInProduction"
            type="checkbox"
            checked={product.considerBomInProduction}
            onChange={() =>
              setProduct((prev) => ({
                ...prev,
                considerBomInProduction: !prev.considerBomInProduction,
              }))
            }
          />
        </div>

        <div className="-mx-2">
          <table>
            <tbody>
              <tr>
                <td className="align-baseline">
                  <label>Category:</label>
                </td>
                <td className="align-baseline">
                  <ProductionCategory
                    value={product.productionCategoryId}
                    onChange={(productionCategoryId) =>
                      setProduct((prev) => ({ ...prev, productionCategoryId }))
                    }
                  />
                </td>
              </tr>

              <tr>
                <td className="align-baseline">
                  <label>Routes:</label>
                </td>
                <td className="align-baseline">
                  <ProductionSelector
                    productionId={product.productionId}
                    onSelect={(productionId) =>
                      setProduct((prev) => ({ ...prev, productionId }))
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {product.productionId && (
          <div className="relative mt-4 bg-white dark:bg-gray-900 p-12 rounded-2xl flex items-center justify-center">
            <Production id={product.productionId} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductionView;
